export const selectedColor = "#2F80ED"
export const black = "#00263A"
export const disabledColor = "lightgrey"
